"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FeaturesLayout = require("./FeaturesLayout");
Object.keys(_FeaturesLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FeaturesLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FeaturesLayout[key];
    }
  });
});